import type { Point2d, Rectangle2d } from "."
import { rotatePoint } from "."

export const findCenterOfBox = ({ x, y, w, h, r }: Rectangle2d): Point2d =>
  r === 0
    ? {
        x: x + w / 2,
        y: y + h / 2,
      }
    : rotatePoint({ x, y }, { x: x + w / 2, y: y + h / 2 }, r)
